import React from "react";
import Nin9rsTeamLine from "@/components/Nin9rs/Nin9rsTeamLine";
const colorMapping = {
    ["blue"]: "#0000b3",
    ["red"]: "#ff3131",
    ["yellow"]: "#ffde59",
    ["green"]: "#007a3f",
    ["black"]: "#000",
    ["orange"]: "#ff751f",
    ["pink"]: "#f9a",
    ["purple"]: "#b300b2",
    ["fuchsia"]: "#fa009a",
    ["cyan"]: "#5ce1e6",
};
const Nin9rsConfrontation = ({ teams, competitionId }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const teamsArray = Object.values(teams);
    const emptyData = {
        imageUrl: "",
        name: "",
        color: "black"
    };
    let team1 = emptyData;
    let team2 = emptyData;
    if (0 !== teamsArray.length) {
        team1 = teamsArray[0];
        team2 = teamsArray[1];
    }
    const team1Color = colorMapping[team1.color] || colorMapping["black"];
    const team2Color = colorMapping[team2.color] || colorMapping["black"];
    // @ts-ignore
    return (React.createElement("a", { target: "_blank", href: competitionId ? `/${competitionId}/ryder-cup/livescoring` : "", className: "matchChart" },
        React.createElement(Nin9rsTeamLine, { teamImageUrl: team1.imageUrl, teamName: team1.name, teamScore: (_d = (_b = (_a = team1 === null || team1 === void 0 ? void 0 : team1.score) === null || _a === void 0 ? void 0 : _a.generalOut) !== null && _b !== void 0 ? _b : (_c = team1 === null || team1 === void 0 ? void 0 : team1.score) === null || _c === void 0 ? void 0 : _c.general) !== null && _d !== void 0 ? _d : "??", teamColor: team1Color }),
        React.createElement("label", { className: "versusLabel" }, "VS"),
        React.createElement(Nin9rsTeamLine, { teamImageUrl: team2.imageUrl, teamName: team2.name, teamScore: (_h = (_f = (_e = team2 === null || team2 === void 0 ? void 0 : team2.score) === null || _e === void 0 ? void 0 : _e.generalOut) !== null && _f !== void 0 ? _f : (_g = team2 === null || team2 === void 0 ? void 0 : team2.score) === null || _g === void 0 ? void 0 : _g.general) !== null && _h !== void 0 ? _h : "??", teamColor: team2Color })));
};
export default Nin9rsConfrontation;
